import { SVGProps } from "react";

const PKGitlab = (props: SVGProps<SVGSVGElement>) => <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M23.9627 42L42 27.4152L36.9957 6L30.9661 18.9935H17.9932L11.0151 6L6 27.4152L23.9627 42Z" fill="#2F88FF" stroke="black" strokeWidth={4} strokeLinejoin="round" /></svg>;

export { PKGitlab };